import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IConfig } from '../shared/interfaces/config.interface';
import { SHARED_CONFIG } from '../shared/util-config/token/shared-config.token';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private http = inject(HttpClient);
  private readonly config = inject(SHARED_CONFIG);

  getConfig(): Observable<IConfig | undefined> {
    const headers = new HttpHeaders({
      'X-Origin': this.config.xOrigin,
      'X-User-Origin': this.config.xUserOrigin,
      'X-allow-technical-error-modal': '400|500',
    });

    return this.http
      .get(`${this.config.apiUrl}v2/config`, { headers })
      .pipe(map((response) => response as IConfig));
  }
}
